import { render, staticRenderFns } from "./NewRegisterInvite.vue?vue&type=template&id=244e7756&scoped=true&"
import script from "./NewRegisterInvite.vue?vue&type=script&lang=js&"
export * from "./NewRegisterInvite.vue?vue&type=script&lang=js&"
import style0 from "./NewRegisterInvite.vue?vue&type=style&index=0&id=244e7756&lang=scss&scoped=true&"
import style1 from "./NewRegisterInvite.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e7756",
  null
  
)

export default component.exports